<div class="d-flex h-100">
    <cxone-singleselect-dropdown id="cxone-interval-dropdown"
        *ngIf="context.viewStateLoaded()" 
        class="d-block mr-2 my-auto"
        [ngModel]="getSelectedInterval()"
        (ngModelChange)="context.onIntervalChange()($event)"
        [options]="intervalTypes"
        [primaryKey]="'id'" 
        [isRequired]="false" 
        [search]="false"
        [showFooter]="false"
        [sortKey]="'order'"
        [placeholder]="'Select Interval'">
    </cxone-singleselect-dropdown>
</div>
